<div class="fxlayout-row-spacearound-center">
  <mat-card style="width: 100%">
    <mat-card-title class="card-header-row">
      <h3 i18n style="margin: 0;">Users list</h3>
      <div class="header-actions">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Filter</mat-label>
          <input (input)="applyFilter($event)" [value]="dataSource.filter" matInput placeholder="Filter">
        </mat-form-field>
        <button [routerLink]="['/users/add']" color="accent" mat-mini-fab>
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-card-title>

    <div class="example-container mat-elevation-z8">

      <mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="displayName">
          <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Display Name</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.displayName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Email</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.email }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <mat-header-cell *matHeaderCellDef i18n>First Name</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.firstName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef i18n>Last Name</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.lastName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="googleUid">
          <mat-header-cell *matHeaderCellDef i18n>Google UID</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.googleUid }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="initials">
          <mat-header-cell *matHeaderCellDef i18n>Initials</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.initials }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="roles">
          <mat-header-cell *matHeaderCellDef i18n>Roles</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.type?.join(', ') }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="referent">
          <mat-header-cell *matHeaderCellDef i18n>Referenti (timereports)</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.referent }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="jobClassification">
          <mat-header-cell *matHeaderCellDef i18n>Classificazione</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.jobClassification }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef i18n>Active</mat-header-cell>
          <mat-cell *matCellDef="let row">
            @if (row.active) {
              <mat-icon>done</mat-icon>
            }
            @if (!row.active && row.deactivatedOn) {
              <span>
              deactivated: {{ row.deactivatedOn|timestamp | date }}</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="external">
          <mat-header-cell *matHeaderCellDef i18n>External</mat-header-cell>
          <mat-cell *matCellDef="let row">
            @if (row.external) {
              <mat-icon>done</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef i18n>Actions</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <a [routerLink]="['/users/add',row.id]" mat-icon-button>
              <mat-icon title="update user">edit</mat-icon>
            </a>
            <button (click)="deleteUser(row)" mat-icon-button>
              <mat-icon title="delete user">delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>

      <mat-paginator [pageSizeOptions]="[50, 100, 200, 500]"></mat-paginator>
    </div>
  </mat-card>
</div>
